module.exports = __webpack_public_path__ + "img/T37.e9cbe27e.jpg";